exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.leftBox[data-v-300de0da] {\n    width: 100%;\n    margin-top: 0;\n}\n.crumbs[data-v-300de0da] {\n    margin: 20px auto;\n}\n.rightBox[data-v-300de0da] {\n    display: none;\n}\n}\n", ""]);

